// Market Insights explorer (boxes template: market-insights-explorer): tabs built from box categories.
$(document).ready(function () {
	function activate(tab) {
		const panel = tab.closest('[data-mi-explorer]');
		const tabs = panel.find('[role="tab"]');

		tabs.removeClass('is-active').attr({ 'aria-selected': 'false', tabindex: '-1' });
		tab.addClass('is-active').attr({ 'aria-selected': 'true', tabindex: '0' });

		panel.find('[role="tabpanel"]').attr('hidden', true);
		panel.find('#' + tab.attr('aria-controls')).removeAttr('hidden');

		// On narrow screens the tab list scrolls: bring the active tab into view.
		const list = tab.closest('[role="tablist"]')[0];
		const left = tab[0].offsetLeft - list.offsetLeft;
		if (left < list.scrollLeft || left + tab[0].offsetWidth > list.scrollLeft + list.clientWidth) {
			list.scrollTo({ left: left - (list.clientWidth - tab[0].offsetWidth) / 2, behavior: 'smooth' });
		}
	}

	// When the tab list is wider than the screen, mark which side has more tabs hidden,
	// so the CSS can fade that edge (has-more-left / has-more-right).
	function updateScrollHint(list) {
		const max = list.scrollWidth - list.clientWidth;
		list.classList.toggle('has-more-left', list.scrollLeft > 1);
		list.classList.toggle('has-more-right', max > 1 && list.scrollLeft < max - 1);
	}

	function updateAllScrollHints() {
		$('[data-mi-explorer] [role="tablist"]').each(function () {
			updateScrollHint(this);
		});
	}

	$('[data-mi-explorer] [role="tablist"]').on('scroll', function () {
		updateScrollHint(this);
	});
	$(window).on('resize load', updateAllScrollHints);
	updateAllScrollHints();

	$(document).on('click', '[data-mi-explorer] [role="tab"]', function () {
		activate($(this));
	});

	// Arrow keys move between tabs, Home / End jump to the first / last one.
	$(document).on('keydown', '[data-mi-explorer] [role="tab"]', function (event) {
		const tabs = $(this).closest('[role="tablist"]').find('[role="tab"]:not([disabled])');
		const index = tabs.index(this);
		let next = null;

		if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
		if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
		if (event.key === 'Home') next = 0;
		if (event.key === 'End') next = tabs.length - 1;
		if (next === null) return;

		event.preventDefault();
		const tab = tabs.eq(next);
		activate(tab);
		tab.trigger('focus');
	});
});



// WEBPACK FOOTER //
// ./resources/js/modules/market-insights-explorer.js